import { UserProfile } from "src/app/models/userProfile";
import { RatedAssets } from "src/app/models/ratedAssets";
import { Tokens } from "./tokens";
import {ApplicationName} from './ApplicationName';

export class User {
    _id: string = "";
    userEmailId: string = "";
    name: string = "";
    userId: string = "";
    aboutMe:string="";
    websites:string[]=[];
    skills:string[]=[];
    userSettings: UserProfile = new UserProfile();
    userGroup: string ="";
    tokens: Tokens[] = [new Tokens()];
    assetsSubscribedTo: string[] = [];
    termsAndConditions: string;
    wizard: string;
    showActiveUsersInfo: boolean;
    assetsOwned: string[] = [];
    assetsUploaded: string[] = [];
    assetsRecentlyViewed: string[] = [];
    assetsDownloaded: string[] = [];
    assetsRated: RatedAssets[] = [];
    lastLoginDate :Date;
    applicationName:ApplicationName[] =[];
    constructor() { }
}
